/**
 * The context object and its shape, apart from the provider that fills it.
 *
 * Split for the same reason ToastContext.types.ts is: a file exporting both a
 * component and a non-component loses fast refresh, and eslint says so.
 */

import { createContext } from 'react';
import type { AdministeredTenant } from '../components/roles/administeredTenants';

export interface SelectedTenantValue {
  /** Every organisation this person holds a role in, deduplicated by id. */
  tenants: AdministeredTenant[];
  /** The one the app is showing, or null when they hold none. */
  selected: AdministeredTenant | null;
  /** Ignores an id that is not in `tenants`, so a stale caller cannot widen the set. */
  selectTenant: (tenantId: number) => void;
}

export const SelectedTenantContext =
  createContext<SelectedTenantValue | null>(null);
